import React from "react";

function SkeletonBlock({ height = 18, width = "100%", radius = 12, style = {} }) {
  return (
    <div
      style={{
        width,
        height,
        borderRadius: radius,
        background: "linear-gradient(90deg, rgba(255,255,255,0.05), rgba(255,255,255,0.10), rgba(255,255,255,0.05))",
        backgroundSize: "200% 100%",
        animation: "dashShimmer 1.4s ease-in-out infinite",
        ...style,
      }}
    />
  );
}

export default function DashboardSkeleton() {
  return (
    <div style={{ display: "grid", gap: 18 }}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: 16 }}>
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} style={{ background: "#1d2412", border: "1px solid #1c250e", borderRadius: 20, padding: 18 }}>
            <SkeletonBlock height={14} width="38%" />
            <SkeletonBlock height={36} width="72%" style={{ marginTop: 16 }} />
            <SkeletonBlock height={12} width="52%" style={{ marginTop: 14 }} />
          </div>
        ))}
      </div>

      <div style={{ background: "#1d2412", border: "1px solid #1c250e", borderRadius: 24, padding: 18 }}>
        <SkeletonBlock height={22} width="28%" />
        <SkeletonBlock height={260} style={{ marginTop: 18 }} />
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1.1fr 0.9fr", gap: 16 }}>
        <div style={{ background: "#1d2412", border: "1px solid #1c250e", borderRadius: 24, padding: 18 }}>
          <SkeletonBlock height={22} width="30%" />
          <SkeletonBlock height={210} style={{ marginTop: 18 }} />
        </div>
        <div style={{ background: "#1d2412", border: "1px solid #1c250e", borderRadius: 24, padding: 18 }}>
          <SkeletonBlock height={22} width="24%" />
          <div style={{ display: "grid", gap: 12, marginTop: 18 }}>
            {Array.from({ length: 5 }).map((_, index) => (
              <SkeletonBlock key={index} height={44} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
